package com.example.mystybag.core.extensions

inline fun <reified R> Any.cast(): R = this as R
inline fun <reified R> Any?.safeCast(): R? = this as? R